/*
 * Copyright 2023 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

.aria-table,
.aria-table * {
  box-sizing: border-box;
}

.aria-table {
  width: 800px;
  height: 300px;
  display: block;
  position: relative;
  overflow: auto;

  .aria-table-rowGroup {
    display: block;
  }
  .aria-table-rowGroupHeader {
    position: sticky;
    top: 0;
    background: var(--spectrum-gray-100);
  }
  .aria-table-row {
    display: flex;
  }
  .aria-table-headerRow {
    [role="columnheader"] {
      border-bottom: 2px solid gray;
    }
  }
}
